export default __webpack_public_path__ + "static/media/sesame.b1df1d10.JPG";